import React, { useMemo } from "react";
import Select from "components/Form/fields/Select";
import startCase from "lodash/startCase";
import { getDataFieldSets } from "utils/table";
import get from "lodash/get";
import { DESKTOP_SCROLL_CONTAINER, scrollTopForId } from "utils/scroll";

const DEFAULT_CLASSES = {
  container: "flex flex-row flex-shrink-0 pt3",
  item: "pl3"
};

const SelectFields = ({
  data,
  onChange,
  config,
  state,
  customClasses,
  scrollTopOnChange
}) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const fields = get(config, "fields", []);
  const formatters = get(config, "formatters", {});
  const labels = get(config, "labels", {});

  const sets = useMemo(
    () =>
      getDataFieldSets({
        data,
        fields
      }),
    []
  );

  const fieldNodes = fields.reduce((memo, field, fieldIndex) => {
    const options = sets[field];
    const activeFieldSelection = state.find(({ id }) => id === field);

    let activeFieldValue = activeFieldSelection
      ? activeFieldSelection.value
      : "";

    if (options && options.length > 1) {
      let activeValueUID = "";
      const selectOptions = options.reduce(
        (memo, uid) => {
          const fieldFormatter = formatters && formatters[field];
          const transformer = fieldFormatter ? fieldFormatter : startCase;

          let transformedValue = transformer(uid);
          if (typeof transformedValue === "string") {
            transformedValue = transformedValue.toLowerCase();
          }
          if (typeof activeFieldValue === "string") {
            activeFieldValue = activeFieldValue.toLowerCase();
          }

          if (transformedValue === activeFieldValue) {
            activeValueUID = uid;
          }

          memo.push({
            uid,
            label: uid,
            transformer: fieldFormatter ? fieldFormatter : startCase
          });
          return memo;
        },
        [
          {
            uid: "",
            label: "All"
          }
        ]
      );

      const selectProps = {
        options: selectOptions,
        value: activeValueUID,
        onChange: () => (evt) => {
          const selection = evt.currentTarget.value;
          onChange(field, selection);

          scrollTopOnChange && scrollTopForId(DESKTOP_SCROLL_CONTAINER);
        },
        customClasses: {
          container: "w-100",
          input:
            "border-box input-reset ba br2 b--black-20 pa2 db w-100 pointer shadow-0 pr3"
        },
        iconStyle: {
          right: 2
        }
      };

      memo.push(
        <div className="w-auto" key={fieldIndex} className={classes.item}>
          <div className="f7 pb2 black-80">
            {labels && labels[field] ? labels[field] : startCase(field)}
          </div>
          <Select {...selectProps} />
        </div>
      );
    }

    return memo;
  }, []);

  if (fieldNodes.length) {
    return <div className={classes.container}>{fieldNodes}</div>;
  } else {
    return null;
  }
};

export default SelectFields;
